import React from 'react'
import { Link } from 'react-router-dom';
import { FaBullhorn } from "react-icons/fa";
import Liveagents from '../pages/images/liveagent.png'
import Agenthistory from '../pages/images/agentHistory.png'
import Livelist from '../pages/images/LiveList.png'
import agentContect from '../pages/images/agentContect.png'

const AgentsConfiguration = [
    {
        title: "Live Agents",
        description: "Manage your active live chats.",
        slug: "/WAMessage/UserChatBox",
        image: Liveagents
    },
    {
        title: "Live Agents History",
        description: "View and search agent chat history.",
        slug: "/WAMessage/UserChatArchive",
        image: Agenthistory
    },
    {
        title: "Agent List",
        description: "View and search agents.",
        slug: "/WAMessage/AgentList",
        image: Livelist
    },
    {
        title: "WhatsApp Contact",
        description: "Manage your Contact.",
        slug: "/WAMessage/WAContact",
        image: agentContect
    }
];

function Agents() {


    return (
        <>
            <div className='w-[100%] pt-0 pl-6 '>
                <div className=' border-[1px] border-[#d6d4d4] w-[100%] p-2 rounded-md  '>
                    <div className='  flex justify-between w-[100%] pl-2 pb-2 border-[#d6d4d4] border-b-[1px] '>
                        <div className='flex items-center gap-1 '>
                            <FaBullhorn className='text-[18px] dark:text-[#fff]' />
                            <span className='text-[14px] text-[#000] font-semibold dark:text-[#fff]'> Live Agents Configuration   </span>
                        </div>
                    </div>
                    <div className='w-[100%] flex gap-4 flex-wrap  items-center pt-3 pb-5 '>
                        {AgentsConfiguration.map((item, index) => (
                            <div className='text-white border-0 rounded-[20px] py-8 px-1 
        w-full sm:w-[48%] md:w-[30%] lg:w-[22%] xl:w-[15%]
        h-[160px] cursor-pointer text-center 
        [transform-style:preserve-3d] transition-all duration-300 ease-in-out 
        shadow-[0_12px_24px_rgba(0,0,0,0.2),0_6px_10px_rgba(0,0,0,0.1)] 
        hover:shadow-[rgba(0,0,0,0.35)_0px_5px_15px] 
        flex flex-col items-center  duration-400  hover:[transform:rotateX(12deg)_rotateY(-12deg)] group '>
                                <Link to={item.slug}>
                                    <div className='w-[100%] flex justify-center items-center'>
                                        <img className='w-[48px]' src={item.image} alt="" />
                                    </div>
                                    <h1 className='text-[#000] text-[14px] font-semibold transition-all duration-300 group-hover:-translate-y-1 group-hover:-translate-x-1 dark:text-[#fff]'>{item.title}</h1>
                                    <span className='text-[#777777] text-[12px] font-semibold text-center dark:text-[#fff] leading-tight line-clamp-2'>{item.description}</span>
                                </Link>
                            </div>

                        ))
                        }

                    </div>
                    <div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Agents 
